import * as assert from 'assert';
import { ILoginResponse } from '../_interfaces/ServerResponses';
import { ISignUpParams } from '../_stores/AuthorizationStore';
import { apiConstants, processServerResponse } from '../util/apiUtils';

export class AuthService {
    private subPaths = {
        login: 'login',
        signup: 'signup',
        authCheck: 'authCheck',
        signupWithFacebook: 'signup/facebook',
        emailCheck: (email: string) => `${encodeURI(email)}/exists`
    };

    public login(email: string, password: string): Promise<ILoginResponse> {
        console.assert(email, 'Paramater is undefined');
        console.assert(password, 'Paramater is undefined');

        const params = {
            email,
            password
        };

        return this.makeAuthCall(this.subPaths.login, params);
    }

    public loginWithFacebook(email: string, accessToken: string, userId: string) {

        return this.makeAuthCall(this.subPaths.signupWithFacebook, {
            email,
            accessToken,
            userId
        });
    }

    public checkToken(token: string): Promise<ILoginResponse> {
        console.assert(token, 'Paramater is undefined');

        const headers: Headers = new Headers();
        headers.append(apiConstants.headers.Authorization, token);

        return this.makeAuthCall(this.subPaths.authCheck, undefined, headers);
    }

    public signUp(params: ISignUpParams): Promise<ILoginResponse> {
        console.assert(params, 'Paramater is undefined');

        return this.makeAuthCall(this.subPaths.signup, params);
    }

    public checkUserExists(email: string): Promise<boolean> {
        const headers = new Headers();
        headers.append(apiConstants.headers.ContentType, apiConstants.headers.JSON);

        const url = apiConstants.routes.SERVER + this.subPaths.emailCheck(email);

        const requestConfig: any = {
            method: apiConstants.methods.GET,
            headers
        };

        return fetch(url, requestConfig).then(response => response.json());
    }

    private makeAuthCall(subPath: string, params?: {}, extraHeaders?: Headers): Promise<ILoginResponse> {
        console.assert(subPath, 'Paramater is undefined');

        const url: string = apiConstants.routes.SERVER + subPath;

        const headers: Headers = extraHeaders ? extraHeaders : new Headers();
        headers.append(apiConstants.headers.ContentType, apiConstants.headers.JSON);

        const requestConfig: any = {
            method: apiConstants.methods.POST,
            headers
        };

        if (params) {
            requestConfig.body = JSON.stringify(params);
        }

        return fetch(url, requestConfig).then(this.handleAuthResponse);
    }

    private handleAuthResponse(response: Response): Promise<ILoginResponse> {
        return processServerResponse(response).then(data => {
            assert.notEqual(null, data, 'Assertion Fail @ AuthService#handleAuthResponse: no data');

            assert(data, 'Invalid response from server while logging in');
            assert(data.user, 'No user info in response from server while logging in');
            assert(data.token, 'No auth token in response from server while logging in');

            console.log('Auth response: ', data);

            return data as ILoginResponse;
        });
    }
}



// WEBPACK FOOTER //
// ./src/_services/AuthService.ts